import React from 'react'
import withIcon from '@/components/withIcon'

const IconApple = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 48 49"
      fill="none"
    >
      <path
        d="M39.065 14.5898C34.171 10.6528 28.665 13.4898 24 13.4898C19.335 13.4898 13.829 10.6558 8.93501 14.5898C4.44401 18.1998 2.95401 29.1588 9.01101 38.8438C14.823 48.1358 20.684 44.9858 24 44.9858C27.316 44.9858 33.177 48.1358 38.989 38.8438C45.046 29.1588 43.556 18.1998 39.065 14.5898Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M34 0.5V2.5C34 4.35652 33.2625 6.13699 31.9497 7.44975C30.637 8.7625 28.8565 9.5 27 9.5V7.5C27 5.64348 27.7375 3.86301 29.0503 2.55025C30.363 1.2375 32.1435 0.5 34 0.5Z"
        fill="currentColor"
      />
      <path
        d="M24 13.5C24 9.5 21.167 4.75 17 3.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default withIcon(IconApple)
